import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2Linkbox(props) {
  var children = props.children,
      className = props.className,
      textInfo = props.textInfo,
      flat = props.flat,
      disabled = props.disabled,
      image = props.image,
      color = props.color,
      rightIcon = props.rightIcon,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "textInfo", "flat", "disabled", "image", "color", "rightIcon", "tag"]);

  var classes = classNames(className, 'o2-linkbox', rightIcon ? "o2-linkbox--" + rightIcon : false, color ? "o2-linkbox--" + color : false, {
    'o2-linkbox--flat': flat,
    'o2-linkbox--image': image,
    'o2-linkbox--disabled': disabled
  });

  if (!Tag && disabled) {
    Tag = 'div';
  } else if (!Tag) {
    Tag = 'a';
  }

  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }), image && /*#__PURE__*/React.createElement("img", {
    src: image,
    className: "o2-linkbox__img"
  }), children, textInfo && /*#__PURE__*/React.createElement("div", {
    className: "o2-linkbox__info"
  }, textInfo));
}

O2Linkbox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  textInfo: PropTypes.string,
  flat: PropTypes.bool,
  disabled: PropTypes.bool,
  image: PropTypes.string,
  color: PropTypes.oneOf(['grey', 'internal']),
  rightIcon: PropTypes.oneOf(['plus', 'check']),
  tag: PropTypes.string
};
export default O2Linkbox;